module.exports = __webpack_public_path__ + "static/media/01-6WHEELS_CABINET.9456934e.png";